import { useState } from "react"
import FormControlLabel from "@mui/material/FormControlLabel"
import IconButton from "@mui/material/IconButton"
import Switch from "@mui/material/Switch"
import Tooltip from "@mui/material/Tooltip"
import HelpOutlineIcon from "@mui/icons-material/HelpOutline"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

// `label` wraps the icon in a real, focusable button (so the tooltip
// also opens on keyboard focus) — pass it when the tip stands alone
// instead of annotating adjacent text
export const Tip = ({ msg, style, icon, placement = "right", label }) => {
  const Icon = icon ?? HelpOutlineIcon
  const iconEl = (
    <Icon
      sx={{
        fontSize: 16,
        color: "var(--muted)",
        marginLeft: "6px",
        flex: "none",
        ...style,
      }}
    />
  )
  return (
    <Tooltip arrow placement={placement} title={<div>{msg}</div>}>
      {label ? (
        <IconButton size="small" aria-label={label} sx={{ padding: "2px" }}>
          {iconEl}
        </IconButton>
      ) : (
        iconEl
      )}
    </Tooltip>
  )
}

export const ToggleRow = ({ label, checked, onChange, tip }) => (
  <div className="toggle-row">
    <FormControlLabel
      sx={{ margin: 0 }}
      label={<span className="toggle-label">{label}</span>}
      control={<Switch size="small" checked={!!checked} onChange={onChange} />}
    />
    {tip && <Tip msg={tip} />}
  </div>
)

// `open` + `onToggle` make the section controlled: the header stays a
// clickable chevron button that reports clicks instead of tracking its
// own state. `hint` is a muted label shown before the chevron only
// while the section is closed.
export const Section = ({
  title,
  badge,
  hint,
  defaultOpen = true,
  collapsible = true,
  open,
  onToggle,
  children,
}) => {
  const [openState, setOpen] = useState(defaultOpen)
  const controlled = open !== undefined
  const isOpen = controlled ? open : collapsible ? openState : true
  return (
    <section className={`filter-section${isOpen ? " open" : ""}`}>
      {collapsible && (!controlled || onToggle) ? (
        <button
          type="button"
          className="filter-section-header"
          aria-expanded={isOpen}
          onClick={() => (onToggle ? onToggle() : setOpen((o) => !o))}
        >
          <span>{title}</span>
          {badge && <span className="filter-section-badge">{badge}</span>}
          {hint && !isOpen && (
            <span className="filter-section-hint">{hint}</span>
          )}
          <ExpandMoreIcon className="chev" />
        </button>
      ) : (
        <div className="filter-section-header static">
          <span>{title}</span>
          {badge && <span className="filter-section-badge">{badge}</span>}
        </div>
      )}
      {isOpen && <div className="filter-section-body">{children}</div>}
    </section>
  )
}
